document.addEventListener('DOMContentLoaded', function() {
    setInterval(() => {
        document.querySelectorAll('.cart-item.teeinblue-cart-item--priceaddon').forEach(item => {
            item.classList.remove('teeinblue-cart-item--priceaddon');

            item.querySelectorAll('button[disabled]').forEach(btn => {
                btn.removeAttribute('disabled');
            });
        });
    }, 500)
});